(function () {
  var tr = (window.Shopify && Shopify.translation && Shopify.translation.slideshow) || {};
  var PREV = tr.prevSlideMessage || 'Diapositive précédente';
  var NEXT = tr.nextSlideMessage || 'Diapositive suivante';
  var BULLET = tr.paginationBulletMessage || 'Aller à une diapositive';
  var CLOSE = 'Fermer';

  function accessibleName(el) {
    if (!el) return '';
    var labelled = el.getAttribute('aria-label');
    if (labelled && labelled.trim()) return labelled.trim();
    var labelledBy = el.getAttribute('aria-labelledby');
    if (labelledBy) {
      var ids = labelledBy.split(/\s+/);
      var text = ids
        .map(function (id) {
          var node = document.getElementById(id);
          return node ? (node.textContent || '').trim() : '';
        })
        .join(' ')
        .trim();
      if (text) return text;
    }
    var title = el.getAttribute('title');
    if (title && title.trim()) return title.trim();
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function nameControl(el, label) {
    if (!el || accessibleName(el) || el.getAttribute('aria-hidden') === 'true') return;
    el.setAttribute('aria-label', label);
  }

  function labelSwiperAndButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.swiper-button-prev').forEach(function (el) {
      nameControl(el, PREV);
    });
    scope.querySelectorAll('.swiper-button-next').forEach(function (el) {
      nameControl(el, NEXT);
    });
    scope.querySelectorAll('.menu-drawer__close-button').forEach(function (el) {
      nameControl(el, CLOSE);
    });
    scope.querySelectorAll('button[name="commit"], .newsletter-form button[type="submit"], .input-group__btn button[type="submit"]').forEach(function (el) {
      nameControl(el, 'S\'abonner');
    });
    scope.querySelectorAll('.search-bar__button-submit, button.search-bar__button-submit').forEach(function (el) {
      nameControl(el, 'Rechercher');
    });
    scope.querySelectorAll('.swiper-pagination-bullet').forEach(function (el) {
      nameControl(el, BULLET.replace('{{index}}', '').replace('{{ index }}', '').trim() || BULLET);
    });
  }

  function run() {
    labelSwiperAndButtons(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);

  if ('MutationObserver' in window) {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        run();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
